import React, { useRef, useEffect, useState, useCallback } from "react";
import "./Modal.css";
import axios from "axios";
import { X } from "react-bootstrap-icons";
import Slider from "../Slider/Slider";
const Modal = ({ closeModal, project }) => {
  const [dataProject, setDataProject] = useState({});
  const [dataIsCome, setDataIsCome] = useState(false);
  const handelData = useCallback(
    (res) => {
      const selectedProject = res.find((el) => el.projectID === project);
      if (selectedProject) {
        setDataProject(selectedProject);
      }
    },
    [project],
  );

  const fetchData = useCallback(async () => {
    await axios
      .get("./data.json")
      .then((res) => {
        handelData(res.data);
        setDataIsCome(true);
      })
      .catch((err) => console.log(err));
  }, [handelData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const img = useRef();
  return (
    <>
      <div className="backdrop" onClick={() => closeModal()}></div>
      <div className="overlay contener">
        <div className="header">
          <p className="title">{dataProject.name}</p>
          <p className="close" onClick={() => closeModal()}>
            <X />
          </p>
        </div>
        <div className="content">
          <div className="img" ref={img}>
            {dataIsCome && <Slider images={dataProject.images} />}
          </div>
          <div className="desc">
            <p>Project information</p>
            <p>
              ptoject: <span>{dataProject.projectName}</span>
            </p>
            <p>
              Client: <span>{dataProject.Client}</span>
            </p>
            <p>
              Project date: <span>{dataProject.ProjectDate}</span>
            </p>
            <p>
              Project URL: <span>{dataProject.ProjectURL}</span>
            </p>
            <p>
              Project descripion: <span>{dataProject.description}</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
